import React from "react"
import { money } from "./format"
import { MerchantCell } from "../shared/MerchantLabel"

function Badge({ children, tone = "gray" }) {
  const tones = {
    gray: "bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400",
    green: "bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300",
    red: "bg-red-50 dark:bg-red-950/40 text-red-700 dark:text-red-300",
  }
  return <span className={`rounded px-1.5 py-0.5 text-[11px] font-medium ${tones[tone]}`}>{children}</span>
}

export function TopCustomers({ rows, copy, emptyLabel, detailBasePath }) {
  if (!rows || rows.length === 0) return <p className="text-sm text-gray-500 dark:text-gray-400">{emptyLabel}</p>
  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-800">
      {rows.map((r, i) => (
        <li key={r.shop} className="flex items-center gap-3 py-3">
          <span className="w-4 shrink-0 text-sm text-gray-400 dark:text-gray-500">{i + 1}</span>
          <div className="min-w-0 flex-1">
            <MerchantCell name={r.name} shop={r.shop} merchantId={r.merchant_id} detailBasePath={detailBasePath} />
            <div className="mt-1 flex items-center gap-1.5">
              {r.plan && <Badge>{r.plan}</Badge>}
              <Badge tone={r.installed ? "green" : "red"}>
                {r.installed ? copy.installed : copy.uninstalled}
              </Badge>
            </div>
          </div>
          <span className="shrink-0 text-sm font-semibold text-gray-900 dark:text-gray-100">{money(r.ltv_cents, "USD")}</span>
        </li>
      ))}
    </ul>
  )
}

export function TopSubscriptions({ rows, copy, emptyLabel, detailBasePath }) {
  if (!rows || rows.length === 0) return <p className="text-sm text-gray-500 dark:text-gray-400">{emptyLabel}</p>
  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-800">
      {rows.map((r, i) => (
        <li key={`${r.shop}-${i}`} className="flex items-center gap-3 py-3">
          <div className="min-w-0 flex-1">
            <MerchantCell name={r.name} shop={r.shop} merchantId={r.merchant_id} detailBasePath={detailBasePath} />
            <p className="text-xs text-gray-500 dark:text-gray-400">
              {[r.app, r.plan].filter(Boolean).join(" · ")}
            </p>
          </div>
          <span className="shrink-0 text-sm font-semibold text-gray-900 dark:text-gray-100">
            {money(r.amount_cents, "USD")}<span className="text-xs font-normal text-gray-400 dark:text-gray-500">{copy.perMo}</span>
          </span>
        </li>
      ))}
    </ul>
  )
}

export function RecentTransactions({ rows, emptyLabel, detailBasePath }) {
  if (!rows || rows.length === 0) return <p className="text-sm text-gray-500 dark:text-gray-400">{emptyLabel}</p>
  const day = (iso) => new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short" })
  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-800">
      {rows.map((r, i) => {
        const positive = r.amount_cents >= 0
        return (
          <li key={`${r.shop}-${i}`} className="flex items-center gap-3 py-3">
            <div className="min-w-0 flex-1">
              <MerchantCell name={r.name} shop={r.shop} merchantId={r.merchant_id} detailBasePath={detailBasePath} />
              <p className="text-xs text-gray-500 dark:text-gray-400">{r.kind} · {day(r.at)}</p>
            </div>
            <span className={`shrink-0 text-sm font-semibold ${positive ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"}`}>
              {positive ? "+" : "-"}{money(Math.abs(r.amount_cents), "USD", { maximumFractionDigits: 2 })}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
